export const AGREEMENT_TYPE = {
  LOAN: "LOAN",
};
